<div class="p-5">
  <div class="flex justify-between items-center p-4">
    <div class="text-xl text-gray-700 font-bold mt-2">Editar Veículo</div>
    <div class="flex gap-3 justify-center items-center">
      <button mat-button class="btn-tg-cancel" (click)="close()">
        Cancelar
      </button>
      <button mat-flat-button class="btn-tg" [disabled]="form.invalid || loading || plateExists"
        (click)="editItem()">
        @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner" selected-track-color="red"></mat-spinner>
        } @else {
        Editar
        }
      </button>
    </div>
  </div>

  <div [formGroup]="form" class="py-2 px-6">
    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg mt-message-input w-6/12" appearance="outline">
        <mat-label>Placa Veículo</mat-label>
        <input matInput formControlName="VehicleCode" [mask]="'AAAAAAA'" />

        <mat-hint *ngIf="checkingPlate" class=" mr-3">
          Verificando placa...
        </mat-hint>
        @if(plateExists) {
        <mat-hint class="text-red-500 mr-3">
          Esta placa já está cadastrada
        </mat-hint>
        }
      </mat-form-field>
      <mat-form-field class="input-tg mt-message-input w-6/12" appearance="outline">
        <mat-label>Modelo Veículo</mat-label>
        <input matInput formControlName="TypeVehicle" [matAutocomplete]="autoModels" />
        <mat-autocomplete #autoModels="matAutocomplete" [displayWith]="displayType">
          <mat-option *ngFor="let model of filteredModelsVehicles | async" [value]="model">
            {{ model.modelo }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="input-tg mt-message-input w-6/12" appearance="outline">
        <mat-label>Fornecedor</mat-label>
        <input matInput formControlName="supplier" readonly />
        <button mat-icon-button matSuffix (click)="addSupplier()">
          <mat-icon>add</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field class="input-tg mt-message-input w-6/12" appearance="outline">
        <mat-label>Tipo de Veículo</mat-label>
        <mat-select formControlName="TipoVeiculoId">
          <mat-option *ngFor="let type of listVehicleTypes" [value]="type.id">
            {{ type.descricao }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex justify-start gap-4  items-center">

      <mat-slide-toggle class="w-4/12" formControlName="active" (click)="fillForm()" [disabled]="true">{{
        form.get('active')?.value ? 'TG/Frota' : 'Veículo Fornecedor'
        }}</mat-slide-toggle>

    </div>
    <div class="flex justify-end gap-4 items-center">


    </div>

    <div class="flex justify-start mt-5 items-center">
      <div class="text-xl text-gray-700 font-bold mt-2">Adicionar Documento</div>
    </div>

    <div class="flex justify-between items-center gap-4">
      <mat-form-field class="input-tg mt-message-input w-6/12" appearance="outline">
        <mat-label>Tipo Documento</mat-label>
        <mat-select formControlName="typeDocument">
          <mat-option *ngFor="let type of typeDocuments" [value]="type">
            {{ type.descricao }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg mt-message-input w-6/12" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>
      <div class="mt-message-input w-6/12">
        <input hidden type="file" (change)="onFileSelected($event)" #fileInput />
        <mat-form-field class="input-tg input-btn-icon w-full" appearance="outline">
          <mat-label>Arquivo</mat-label>
          <input matInput formControlName="file" readonly />
          <button mat-icon-button matSuffix (click)="fileInput.click()">
            <mat-icon>upload</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <button mat-icon-button class="btn-icon-outline" [disabled]="formDoc.invalid || loading" (click)="addDocument()">
        <mat-icon>add</mat-icon>
      </button>

    </div>

    <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
  </div>
</div>